import { UserOutlined } from "@ant-design/icons";
import { Button, Form } from "antd";
import React from "react";
import { useForm } from "react-hook-form";
import { useErrorToast } from "../../../api";
import { InputField } from "../../atoms/FormElement";
import { getValidationProps } from "../../libs/form";
import { useLoginWithSSO } from "./api";

type SSOLoginFormValues = {
  email: string;
};

export const SSOLogin = () => {
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<SSOLoginFormValues>();

  const { loginWithSSO, isPending, isError, error } = useLoginWithSSO({
    onSuccess: (result) => {
      if (result?.url) location.href = result.url;
    },
  });

  useErrorToast({ isEnabled: isError, error, fallbackError: "Unable to sign in. Please try again." });

  const onSubmit = async ({ email }: SSOLoginFormValues) => {
    await loginWithSSO({ email: email.toLowerCase() });
  };

  return (
    <Form name="sso_login" className="login-form" onFinish={handleSubmit(onSubmit)}>
      <InputField
        fieldname="email"
        control={control}
        iProps={{
          placeholder: "Email",
          size: "large",
          prefix: <UserOutlined className="site-form-item-icon" />,
        }}
        {...getValidationProps({
          fieldName: "email",
          errors,
          isRequired: true,
          rules: {
            pattern: {
              value: /^[\w.-]+@([\w-]+\.)+[\w-]{2,4}$/,
              message: "Enter valid email address",
            },
          },
        })}
      />
      <Form.Item className="mb-0">
        <Button htmlType="submit" className="microsoft-login-button" size="large" loading={isPending}>
          <span className="microsoft-logo" aria-hidden="true">
            <span className="microsoft-logo-red" />
            <span className="microsoft-logo-green" />
            <span className="microsoft-logo-blue" />
            <span className="microsoft-logo-yellow" />
          </span>
          <span>Sign in with Microsoft</span>
        </Button>
      </Form.Item>
    </Form>
  );
};
